module.exports = __webpack_public_path__ + "static/img/core-item-3.010f2db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lowCodePhone/core-item-3.png
// module id = kg56
// module chunks = 0